import React__default from 'react';
import { Tag } from '../atoms/Tag.js';
import { Text } from '../atoms/Text.js';
import { RichDescription } from './RichDescription.js';
import './TitleGroup.scss';

const headingLevelMap = {
    page: 1,
    section: 2,
    subsection: 3,
    group: 4,
    subgroup: 5,
    minor: 6,
};
const TitleGroup = ({ title, description, className, level = 'section', variant = 'default', titleId, descriptionId, tag, maxWidth = '72ch', rightComponent, leftComponent, id, titleWeight = 'bold', }) => {
    const numericLevel = typeof level === 'number' ? level : headingLevelMap[level];
    const Heading = `h${numericLevel}`;
    const renderTag = () => {
        if (!tag)
            return null;
        if (React__default.isValidElement(tag)) {
            return tag;
        }
        const tagProps = tag;
        return React__default.createElement(Tag, { ...tagProps }, tagProps.children);
    };
    const maxWidthValue = maxWidth === 'full' ? '100%' : maxWidth;
    // Map heading level to Text size
    const getTitleSize = () => {
        switch (numericLevel) {
            case 1:
                return 'display100';
            case 2:
                return 'title200';
            case 3:
                return 'heading';
            case 4:
                return 'heading';
            case 5:
                return 'body';
            case 6:
                return 'bodySmall';
            default:
                return 'heading';
        }
    };
    // Map heading level to description Text size
    const getDescriptionSize = () => {
        switch (numericLevel) {
            case 1:
                return 'title100';
            case 2:
            case 3:
                return 'body';
            case 4:
            case 5:
            case 6:
                return 'bodySmall';
            default:
                return 'body';
        }
    };
    const getSpacing = () => {
        switch (numericLevel) {
            case 1:
                return 12;
            case 2:
            case 3:
            case 4:
            case 5:
                return 8;
            case 6:
                return 2;
        }
    };
    const titleSize = getTitleSize();
    const descriptionSize = getDescriptionSize();
    const descriptionColor = numericLevel >= 2 ? 'secondary' : 'primary';
    const hasHeader = !!(title || tag || rightComponent || leftComponent);
    const spacing = hasHeader && description ? getSpacing() : undefined;
    // Determine if description is RichDescriptionProps (object) or string
    const isRichDescription = description && typeof description === 'object' && 'children' in description;
    return (React__default.createElement("hgroup", { "data-rev-component": 'title-group', "data-rev-variant": variant, "data-rev-level": numericLevel, className: className, style: { '--title-group-max-width': maxWidthValue }, id: id },
        React__default.createElement("div", { className: 'title-group-layout--rev', style: {
                '--tg-align-items': leftComponent || rightComponent ? 'flex-start' : undefined,
            } },
            leftComponent && React__default.createElement("div", { className: 'title-group-left--rev' }, leftComponent),
            React__default.createElement("div", { className: 'title-group-main--rev' },
                React__default.createElement("div", { className: 'title-group-content--rev', style: {
                        '--tg-spacing': spacing ? `${spacing}px` : undefined,
                    } },
                    hasHeader && (React__default.createElement("div", { className: 'title-group-header--rev' },
                        title && (React__default.createElement(Text, { tag: Heading, size: titleSize, weight: titleWeight, id: titleId, className: 'title-group-title--rev' }, title)),
                        tag && renderTag())),
                    description &&
                        (isRichDescription ? (React__default.createElement("div", { id: descriptionId, className: 'title-group-description-wrapper--rev' },
                            React__default.createElement(RichDescription, { ...description, textSize: descriptionSize, textColor: descriptionColor, className: 'title-group-description--rev' }))) : (React__default.createElement(Text, { tag: 'p', size: descriptionSize, color: descriptionColor, weight: 'regular', id: descriptionId, className: 'title-group-description--rev' }, typeof description === 'string'
                            ? description
                            : String(description)))))),
            rightComponent && React__default.createElement("div", { className: 'title-group-right--rev' }, rightComponent))));
};

export { TitleGroup };
//# sourceMappingURL=TitleGroup.js.map
